import React, { useState } from "react";
import { Input, InputGroup, InputGroupAddon, Form, Button, Container, Row, Col } from "reactstrap";

import { toast } from "react-toastify";
import Card from "../Card/Cards"
import Axios from "axios";
import Cards from "../Card/Cards";
import Footer from "../Layout/Footer";

const apiKey = "563492ad6f91700001000001a2dd8fcf4d8b4f33b02c26b833ab6eeb";

const Home = () => {
    const [pass, setPass] = useState([])
    const [query, setQuery] = useState('');
    // { { console.log(query) } }

    const Search = async () => {
        try {
            const { data } = await Axios.get(`https://api.pexels.com/v1/search?query=${query}&per_page=44`, {
                headers: {
                    Authorization: apiKey
                }
            });
            // console.log({data})
            const { photos } = data;
            const pic = () => photos.map(photos => ({
                smallImage: photos.src.small,
                largeImage: photos.src.large,
                potraitImage: photos.src.portrait,
                p_url: photos.url,
                author: photos.photographer,
                author_url: photos.photographer_url,
                id: photos.id
            }))
            setPass(pic)

        } catch (error) {
            toast('Unable To Find AnyThing Please Try Again Later', { type: "error" })
        }

    }
    return (
        <div>
            <Container>
                <Row className="mt-3">
                    <Col className="md-6">
                        <InputGroup>
                            <Input type="text" value={query} placeholder="Search Here"  required="required" onChange={e => setQuery(e.target.value)} />
                            <InputGroupAddon addonType="append">
                                <Button type="button" className="btn btn-secondary"  onClick={Search}>Search</Button>
                            </InputGroupAddon>

                        </InputGroup>
                        <p className="text-danger">
                        *please enter the topic name you want to search.example:phone,home,tea,coffee
                        </p>
                    </Col>

                </Row>

            </Container>
            <h3 className="text-center">Images </h3>
            <hr></hr>
            <Row>
            {
                pass.map(pass => (
                    <Col md={3} key={pass.id}>
                        <Cards pass={pass}></Cards>
                    </Col>
                ))
            }
            </Row>
           
           <Footer></Footer>
        </div>
    )
}

export default Home